<template>
  <v-container fluid class="customer-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Customer Information</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Photo</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                    <v-row justify="center">
                      <v-col cols="12" md="3" sm="6">
                      <v-form>
                        <p class="text-h5">Create New Customer</p>
                        <v-text-field
                          class="mb-4"
                          v-model="customer.customername"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Customer Name"
                          persistent-hint
                          single-line hint="Enter the customername">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="customer.customercontact"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Contact Person"
                          persistent-hint
                          single-line hint="Enter the contact person">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="customer.customerphone"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Phone"
                          persistent-hint
                          single-line hint="Enter the customer phone">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="customer.customermobile"
                          outlined
                          dense
                          placeholder="Mobile"
                          persistent-hint
                          single-line hint="Enter the customer mobile">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items="['Customer', 'Other Customer']"
                          v-model="customer.customertype"
                          v-bind:error="errorindex == 3"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the customer type">
                        </v-select>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3" sm="6">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-textarea
                          v-model="customer.customeraddress"
                          outlined
                          rows=3
                          label="Address"
                          hint="please enter the customer address"
                        ></v-textarea>
                        <v-select
                          class="mb-4"
                          :items="regions.map(x => {
                            return {text: x.regionname, value: x._id};
                          })"
                          v-model="customer.regionid"
                          v-bind:error="errorindex == 4"
                          outlined
                          dense
                          placeholder="Region"
                          persistent-hint
                          single-line hint="Please choose the region">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="townships.map(x => {
                            return {text: x.townshipname, value: x._id};
                            })"
                          v-model="customer.townshipid"
                          v-bind:error="errorindex == 5"
                          outlined
                          dense
                          placeholder="Township"
                          persistent-hint
                          single-line hint="Please choose the township">
                        </v-select>
                        <v-row no-gutters>
                          <v-col cols="12" md="6">
                            <v-switch
                              v-model="customer.customerstatus"
                              color="primary"
                              v-bind:label="customer.customerstatus=='Active' ? customer.customerstatus : 'Inactive'"
                              value="Active"
                              false-value="Inactive"
                              hint="Status"
                              persistent-hint
                            ></v-switch>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-switch
                              color="primary"
                              v-model="customer.isReceiptNotify"
                              hint="Notify Receipt"
                              :false-value="false"
                              persistent-hint
                            ></v-switch>
                          </v-col>
                        </v-row>


                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="6" sm="5">
                        <div class="d-flex justify-center">
                        <v-btn
                            to="/customer/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Upload Photo</p>
                        <p>Photo:</p>

                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="createCustomer()">
                            Save
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="3"></v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      imageurl: undefined,
      customer: {
        customerstatus: 'Active'
      },
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },

  methods: {
    ...mapActions('Customer', ['createCustomerRequest','getCustomersRequest']),
    ...mapActions('Region', ['getRegionsRequest']),
    ...mapActions('Township', ['getTownshipsRequest']),
    checkError(){
      if(!this.customer.customername){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.customer.customercontact){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.customer.customerphone){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.customer.customertype){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      if(!this.customer.regionid){
        this.haserrors = true;
        this.errorindex = 4;
        return false;
      }
      if(!this.customer.townshipid){
        this.haserrors = true;
        this.errorindex = 5;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    createCustomer() {
      this.createCustomerRequest(this.customer)
      this.getCustomersRequest()
      router.push('/customer/list')
    },
    createImage(file) {
      const reader = new FileReader();
      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.customer.customerimage = file;
      this.customer.imagename = file.name;
      this.createImage(file);
    }
  },
  computed: {
    ...mapState('Customer', ['isReceiving']),
    ...mapState('Region', ['regions']),
    ...mapState('Township', ['townships']),
    ...mapState('List', ['lists']),
  },
  async created () {
    if(this.regions.length==0) await this.getRegionsRequest();
    if(this.townships.length==0) await this.getTownshipsRequest();
  },
}
</script>
<style src="./Add.scss" lang="scss"></style>
